// Approximate geographic bounding boxes for US states (+ DC), keyed by the exact
// full state name used in onboardingConstants US_STATES. Each value is
// [northLat, eastLng, southLat, westLng].
//
// Used to geo-target the renter "Browse Trailers Near Me" CTA: we hand the
// SearchPage a real `address` + `bounds` so the renter lands inside their own
// state (zoomable from there) instead of a keyword string that doesn't filter
// by location. Values are rounded to ~2-3 decimals; good enough to frame the
// state, which is all we need for an initial browse view.
const STATE_BOUNDS = {
  Alabama: [35.008, -84.889, 30.144, -88.473],
  Alaska: [71.539, -129.974, 51.209, -179.148],
  Arizona: [37.004, -109.045, 31.332, -114.818],
  Arkansas: [36.5, -89.644, 33.004, -94.618],
  California: [42.009, -114.131, 32.528, -124.482],
  Colorado: [41.003, -102.041, 36.993, -109.06],
  Connecticut: [42.05, -71.787, 40.98, -73.727],
  Delaware: [39.839, -75.048, 38.451, -75.789],
  'District of Columbia': [38.996, -76.909, 38.792, -77.12],
  Florida: [31.001, -80.031, 24.396, -87.635],
  Georgia: [35.001, -80.751, 30.356, -85.605],
  Hawaii: [22.235, -154.806, 18.911, -160.247],
  Idaho: [49.001, -111.043, 41.988, -117.243],
  Illinois: [42.508, -87.02, 36.97, -91.513],
  Indiana: [41.761, -84.784, 37.772, -88.098],
  Iowa: [43.501, -90.14, 40.375, -96.639],
  Kansas: [40.003, -94.588, 36.993, -102.052],
  Kentucky: [39.147, -81.965, 36.497, -89.571],
  Louisiana: [33.019, -88.817, 28.929, -94.043],
  Maine: [47.46, -66.949, 43.058, -71.084],
  Maryland: [39.723, -75.049, 37.886, -79.487],
  Massachusetts: [42.887, -69.928, 41.187, -73.508],
  Michigan: [48.306, -82.413, 41.696, -90.418],
  Minnesota: [49.384, -89.489, 43.499, -97.239],
  Mississippi: [34.996, -88.098, 30.174, -91.655],
  Missouri: [40.614, -89.099, 35.996, -95.774],
  Montana: [49.001, -104.039, 44.358, -116.05],
  Nebraska: [43.002, -95.308, 39.999, -104.053],
  Nevada: [42.002, -114.039, 35.002, -120.006],
  'New Hampshire': [45.305, -70.61, 42.697, -72.557],
  'New Jersey': [41.357, -73.894, 38.928, -75.564],
  'New Mexico': [37.0, -103.002, 31.332, -109.05],
  'New York': [45.016, -71.856, 40.496, -79.763],
  'North Carolina': [36.588, -75.461, 33.842, -84.322],
  'North Dakota': [49.001, -96.554, 45.935, -104.049],
  Ohio: [42.327, -80.519, 38.403, -84.82],
  Oklahoma: [37.002, -94.431, 33.616, -103.002],
  Oregon: [46.292, -116.463, 41.992, -124.566],
  Pennsylvania: [42.269, -74.69, 39.72, -80.519],
  'Rhode Island': [42.019, -71.12, 41.146, -71.862],
  'South Carolina': [35.216, -78.541, 32.033, -83.354],
  'South Dakota': [45.945, -96.436, 42.48, -104.058],
  Tennessee: [36.678, -81.647, 34.983, -90.31],
  Texas: [36.501, -93.508, 25.837, -106.646],
  Utah: [42.001, -109.041, 36.998, -114.052],
  Vermont: [45.017, -71.465, 42.727, -73.438],
  Virginia: [39.466, -75.242, 36.541, -83.675],
  Washington: [49.002, -116.916, 45.544, -124.849],
  'West Virginia': [40.639, -77.719, 37.202, -82.645],
  Wisconsin: [47.08, -86.805, 42.492, -92.889],
  Wyoming: [45.006, -104.052, 40.995, -111.056],
};

export default STATE_BOUNDS;
